import { NodoDto } from "@/api";
import RipetitoreIcon from "@/assets/repeater.png";
import { Box, IconButton } from "@mui/material";
import { Handle, Position } from "@xyflow/react";
import { useNavigate } from "react-router-dom";
import LaunchIcon from "@mui/icons-material/Launch";
import { useTranslation } from "react-i18next";

export default function GrafoRipetitore({
  data: { nodo },
}: {
  data: { nodo: NodoDto };
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Handle type="target" position={Position.Top} />

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={0.5}
        sx={{ position: "relative" }}
      >
        <img
          src={RipetitoreIcon}
          width={24}
          style={{ paddingTop: 4 }}
          alt={t("grafo.ripetitore")}
        />

        <Box
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
          }}
        >
          {nodo.nome}
          <IconButton
            sx={{ color: "gray", mt: '-2px' }}
            title={t("azioni.apri")}
            size="small"
            color="primary"
            onClick={() => {
              navigate(`/nodi/${nodo.id}`);
            }}
          >
            <LaunchIcon />
          </IconButton>
        </Box>
      </Box>
    </>
  );
}
